import React, { Component } from "react";
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import mainLogo from'../neurotoolkit.png';

class Navigation extends Component {
	render() {
    return (
<div>
<Navbar collapseOnSelect>
  <Navbar.Header pullLeft>
         <a href="http://neurotoolkit.com/"><img src={mainLogo} style={{padding:15,width:200}} alt="neurotoolkit logo"/></a>
    <Navbar.Toggle />
  </Navbar.Header>
  <Navbar.Collapse>
    <Nav pullRight>
      <NavItem href="http://neurotoolkit.com/">Home</NavItem>
    </Nav>
  </Navbar.Collapse>
</Navbar>
</div>
    );
}
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Components/Navigation.js